module.exports = "h4 {\r\n    color: #522E91;\r\n}\r\n\r\n.save_project {\r\n    width: 135px;\r\n    height: 30px;\r\n    padding: 2px;\r\n    background: #fff;\r\n    border: 1px solid #777;\r\n    border-radius: 0;\r\n    color: #522E91;\r\n    margin: 25px 5px 0;\r\n}\r\n\r\n.descriptiontextbox {\r\n    width: 100%;\r\n    min-height: 100px;\r\n}\r\n\r\n.center-align {\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/employee/dashboard-employee/request-unlock-dialog/request-unlock-dialog.component.css
// module id = ./src/app/employee/dashboard-employee/request-unlock-dialog/request-unlock-dialog.component.css
// module chunks = main